import styles from './color_menu_item.module.css';

export type ColorMenuItemProps = {
  value: string;
  label: string;
};

export function ColorMenuItem({ value, label }: ColorMenuItemProps) {
  return (
    <div className={styles.color_container}>
      <div
        className={styles.color_component}
        style={{ backgroundColor: value }}
      />
      {label}
    </div>
  );
}
